import { render, staticRenderFns } from "./OrdensServicoList.vue?vue&type=template&id=3c785cb3&scoped=true&"
import script from "./OrdensServicoList.vue?vue&type=script&lang=js&"
export * from "./OrdensServicoList.vue?vue&type=script&lang=js&"
import style0 from "./OrdensServicoList.vue?vue&type=style&index=0&id=3c785cb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c785cb3",
  null
  
)

export default component.exports